import { addMonths, format, parseISO, setDate } from 'date-fns'

import { GerenciadorPosConclusaoBase } from '@/domain/simulador/gerenciador-pos-conclusao-base'
import { dateToUTC } from '@/utils/date.utils'

export class GerenciadorPosConclusaoSacocVParcelado extends GerenciadorPosConclusaoBase {
  override deveGerarPosConclusao = () => ({ sucesso: true })

  override criarGrupo(
    valor: number,
    dataSaldo: string,
    dataPrevistaEntregaBloco: string,
    dataSimulacao: string,
    totalDeMesesDoParcelamentoDeMensais?: number | null,
    valorBaseSaldo?: number,
    dataUltimaEntrada?: string | null,
  ) {
    const empreendimentoEntregue = dataPrevistaEntregaBloco < dataSimulacao
    const dataReferencia = empreendimentoEntregue ? dataSaldo : dataPrevistaEntregaBloco

    const dataReferenciaPrazo = dataUltimaEntrada ?? dataSimulacao

    const dataInicio = format(setDate(addMonths(parseISO(dateToUTC(dataReferencia)), 1), 10), 'yyyy-MM-dd')
    const dataFim = format(
      setDate(addMonths(parseISO(dateToUTC(dataReferenciaPrazo)), totalDeMesesDoParcelamentoDeMensais ?? 1), 10),
      'yyyy-MM-dd',
    )
    const valorCalculado = valor ?? (valorBaseSaldo ?? 0) / (totalDeMesesDoParcelamentoDeMensais ?? 1)
    return super.criar(dataInicio, dataFim, valorCalculado)
  }
}
